document.addEventListener("DOMContentLoaded", (event) => { 


const buttons = document.querySelectorAll(".unit-btn");
  const cells = document.querySelectorAll(".size-chart td[data-inch]");

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      buttons.forEach((btn) => btn.classList.remove("active"));
      button.classList.add("active");

      const unit = button.dataset.unit;

      cells.forEach((cell) => {
        cell.textContent = cell.dataset[unit];
      });
    });
  });
  })

  document.querySelectorAll('.custom-select').forEach(select => {
  const trigger = select.querySelector('.selected-option');
  const list = select.querySelector('.thb-currency-list');
  const input = select.querySelector('.country-code-input');

  trigger.addEventListener('click', () => {
    select.classList.toggle('open');
  });

  list.querySelectorAll('.currency-item').forEach(item => {
    item.addEventListener('click', () => {
      trigger.textContent = item.textContent;
      input.value = item.dataset.countryCode;

      select.classList.remove('open');

      // Trigger change event if Shopify listens to it
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  document.addEventListener('click', e => {
    if (!select.contains(e.target)) {
      select.classList.remove('open');
    }
  });
});